import { Employer, transformSearchResultsToNuggets } from '@backrs_ui/common-ui';

import { SEARCH_CATEGORIES } from '@backrs_ui/grow-ui/src/pages/Search/search.filters';
import { SearchCategory } from '@backrs_ui/grow-ui/src/pages/Search/search.types';
import { useSearchForEmployerResourcesQuery } from '@backrs_ui/grow-ui/src/redux/employer/employer.api';

export const useFetchOpportunitiesSectionData = (
  employer: Employer,
  selectedTypes: SearchCategory[] = [],
) => {
  const defaultTypes = [
    SEARCH_CATEGORIES.CAREER_OPPORTUNITIES_INTERNSHIPS,
    SEARCH_CATEGORIES.CAREER_OPPORTUNITIES_JOBS,
  ];

  const typesToSend = selectedTypes.length > 0 ? selectedTypes : defaultTypes;

  const { data, isLoading } = useSearchForEmployerResourcesQuery(
    {
      employer_id: employer.id,
      types: typesToSend,
      also_match_sponsor_and_validator: true,
    },
    {
      skip: !employer.name,
    },
  );

  const opportunities = data ? transformSearchResultsToNuggets(data.results) : { nuggets: [] };

  return { opportunities: opportunities.nuggets, isLoading };
};
